import { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Uncaught error in React tree:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div role="alert" className="error-boundary-fallback">
          <h2>Something went wrong.</h2>
          <p>Please refresh the page. If the problem persists, contact Henri at vandeputtehenri@gmail.com.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
